/* unplugin-vue-components disabled */import { render } from "./test.vue?vue&type=template&id=2756f409&scoped=true"
import script from "./test.vue?vue&type=script&lang=js"
export * from "./test.vue?vue&type=script&lang=js"

import "./test.vue?vue&type=style&index=0&id=2756f409&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2756f409"]])

export default __exports__